<div class="bc-workitem-activity-indicator">
  <div class="counter" [ngClass]="optionalClassName">
    <div class="circles">
      <svg-icon *ngIf="unansweredMessageCount > 0 && !forceDisableRedDots"
                class="bc-status-circle"
                icon="{{ unansweredMessageIcon }}"
                attr.data-automation-id="{{ 'unanswered-' + unansweredMessageIcon }}"></svg-icon>
    </div>
    <div class="chat-wrap-up-indicator" *ngIf="isWrapUpIconVisible">
      <svg-icon class="bc-status-closed"
                icon="wrap-up"></svg-icon>
    </div>
    <div class="secs-remain-value"
         *ngIf="showSecondsRemaining"
         [attr.data-automation-id]="optionalClassName + 'remaining'">
      {{ secondsRemainingDisplay }}
    </div>
    <div class="elapsed-timer-value"
         [ngClass]="timerDisplayClass" *ngIf="showCounter() && timerDisplay"
         [attr.data-automation-id]="optionalClassName + 'elapsed'">
      {{ timerDisplay }}
    </div>
  </div>
</div>
